<template>
  
    <v-card-text class="modal-body">
      <div class="modal-header">
        <div class="modal-copy">
          <p class="modal-title">Convert Appointment</p>
          <p class="modal-subtitle">This will convert the quotation into an appointment.</p>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <div class="modal-actions">
      <AppButtonFlat
        size="small"
        color="secondary"
        class="px-6"
        variant="outlined"
        @click="modal.close()"
        :disabled="isSubmitting"
      >
        Cancel
      </AppButtonFlat>
      <AppButtonFlat
        size="small"
        class="px-6"
        @click="handleConfirm"
        :loading="isSubmitting"
        :disabled="isSubmitting"
      >
        Confirm
      </AppButtonFlat>
      </div>
    </v-card-actions>

</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { quotationConvert } from "@/shared/services/quotations.api";
import { useSnackbarStore } from "@/shared/stores/snackbar";

const props = defineProps<{
  quotationId: string | number;
  onSuccess?: () => void;
  onConfirm?: () => void;
}>();

const modal = useModalStore();
const snackbar = useSnackbarStore();
const isSubmitting = ref(false);

const actionColor = computed(() => "success");


async function handleConfirm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    await quotationConvert(props.quotationId);
    snackbar.success("Converted to appointment.");

    if (props.onConfirm) props.onConfirm();
    if (props.onSuccess) props.onSuccess();
    modal.close();
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Unable to convert quotation.";
    snackbar.error(message);
  } finally {
    isSubmitting.value = false;
  }
}
</script>

<style scoped>
.quotation-action-modal {
  padding: 8px 8px 12px;
  border-radius: 16px;
}

.modal-body {
  padding: 16px 16px 8px;
}

.modal-header {

}

.modal-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
}

.modal-icon--success {
  background: rgba(16, 185, 129, 0.12);
  color: #10b981;
}

.modal-icon--error {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

.modal-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.modal-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.modal-subtitle {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.modal-actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 16px 12px;
}
</style>
